import { render, staticRenderFns } from "./ProductDistributionTable.vue?vue&type=template&id=8c0bd9b0&"
import script from "./ProductDistributionTable.vue?vue&type=script&lang=js&"
export * from "./ProductDistributionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports